import { jsxs as r, jsx as e, Fragment as C } from "react/jsx-runtime";
import { ChevronDown as D, ChevronRight as z, Play as A, Check as E, Circle as R } from "lucide-react";
import { forwardRef as F } from "react";
import { B as I } from "./Button-icgr8OM9.js";
import { P as B } from "./ProgressRing-C9g1ohUx.js";
const T = {
  position: "fixed",
  bottom: "var(--space-4)",
  insetInlineEnd: "var(--space-4)",
  zIndex: 100,
  background: "var(--bg-surface)",
  border: "1px solid var(--border-default)",
  borderRadius: "var(--radius-xl)",
  boxShadow: "var(--shadow-xl)",
  fontFamily: "var(--font-sans)",
  color: "var(--text-primary)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
}, W = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-3)",
  padding: "var(--space-3) var(--space-4)",
  background: "transparent",
  border: "none",
  width: "100%",
  textAlign: "start",
  cursor: "pointer",
  color: "inherit",
  font: "inherit"
}, _ = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-3)",
  padding: "var(--space-2_5) var(--space-4)",
  background: "transparent",
  border: "none",
  borderTop: "1px solid var(--border-subtle)",
  width: "100%",
  textAlign: "start",
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
  transition: "background var(--duration-fast) var(--ease-out)"
};
function j({ done: l }) {
  return l ? /* @__PURE__ */ e(
    "span",
    {
      "aria-hidden": !0,
      style: {
        width: 18,
        height: 18,
        borderRadius: "50%",
        background: "var(--accent-default)",
        color: "var(--text-on-accent)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto"
      },
      children: /* @__PURE__ */ e(E, { style: { width: 12, height: 12 }, "aria-hidden": !0 })
    }
  ) : /* @__PURE__ */ e(
    R,
    {
      "aria-hidden": !0,
      style: {
        width: 18,
        height: 18,
        color: "var(--text-tertiary)",
        flex: "0 0 auto",
        strokeDasharray: "3 2"
      }
    }
  );
}
const N = F(function({
  items: o,
  collapsed: a,
  onToggleCollapsed: c,
  onItemClick: h,
  onLoadDemo: u,
  title: p,
  completeMessage: x,
  remainingTemplate: f,
  loadDemoLabel: v,
  footerCaption: g,
  "aria-label": s,
  toggleAriaLabel: y = "Toggle checklist",
  style: m,
  ...b
}, k) {
  const n = o.length, i = o.filter((t) => t.done).length, d = n - i, w = n > 0 && d === 0 ? x : f(d), S = {
    ...T,
    width: a ? "auto" : 320,
    ...m
  };
  return /* @__PURE__ */ r(
    "aside",
    {
      ref: k,
      "aria-label": s,
      "data-ls-component": "ftu-checklist",
      "data-collapsed": a || void 0,
      style: S,
      ...b,
      children: [
        /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            className: "ls-focus-ring",
            onClick: c,
            "aria-expanded": !a,
            "aria-label": y,
            style: W,
            children: [
              /* @__PURE__ */ e(
                B,
                {
                  "aria-label": s,
                  value: i,
                  max: n === 0 ? 1 : n,
                  size: 30,
                  centerSlot: /* @__PURE__ */ r("span", { style: { fontSize: "var(--text-2xs)" }, children: [
                    i,
                    "/",
                    n
                  ] })
                }
              ),
              /* @__PURE__ */ r(
                "span",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    flex: "1 1 auto",
                    minWidth: 0
                  },
                  children: [
                    /* @__PURE__ */ e(
                      "span",
                      {
                        style: {
                          fontSize: "var(--text-sm)",
                          fontWeight: "var(--font-weight-bold)",
                          color: "var(--text-primary)"
                        },
                        children: p
                      }
                    ),
                    /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-2xs)", color: "var(--text-secondary)" }, children: w })
                  ]
                }
              ),
              /* @__PURE__ */ e(
                D,
                {
                  "aria-hidden": !0,
                  style: {
                    width: "var(--icon-sm)",
                    height: "var(--icon-sm)",
                    color: "var(--text-secondary)",
                    transition: "transform var(--duration-fast) var(--ease-out)",
                    transform: a ? "rotate(0deg)" : "rotate(180deg)",
                    flex: "0 0 auto"
                  }
                }
              )
            ]
          }
        ),
        a ? null : /* @__PURE__ */ r(C, { children: [
          /* @__PURE__ */ e("ul", { style: { listStyle: "none", padding: 0, margin: 0 }, children: o.map((t) => /* @__PURE__ */ e("li", { style: { margin: 0 }, children: /* @__PURE__ */ r(
            "button",
            {
              type: "button",
              className: "ls-focus-ring",
              onClick: () => h(t.id),
              "data-done": t.done || void 0,
              style: _,
              children: [
                /* @__PURE__ */ e(j, { done: t.done }),
                /* @__PURE__ */ r(
                  "span",
                  {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      flex: "1 1 auto",
                      minWidth: 0
                    },
                    children: [
                      /* @__PURE__ */ e(
                        "span",
                        {
                          style: {
                            fontSize: "var(--text-sm)",
                            fontWeight: "var(--font-weight-semibold)",
                            color: t.done ? "var(--text-tertiary)" : "var(--text-primary)",
                            textDecoration: t.done ? "line-through" : void 0
                          },
                          children: t.title
                        }
                      ),
                      /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-2xs)", color: "var(--text-secondary)" }, children: t.sub })
                    ]
                  }
                ),
                t.done ? null : /* @__PURE__ */ e(
                  z,
                  {
                    "aria-hidden": !0,
                    style: {
                      width: "var(--icon-sm)",
                      height: "var(--icon-sm)",
                      color: "var(--text-tertiary)",
                      flex: "0 0 auto"
                    }
                  }
                )
              ]
            }
          ) }, t.id)) }),
          /* @__PURE__ */ r(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "var(--space-2)",
                padding: "var(--space-3) var(--space-4)",
                borderTop: "1px solid var(--border-subtle)",
                background: "var(--bg-base)"
              },
              children: [
                /* @__PURE__ */ e(
                  I,
                  {
                    variant: "secondary",
                    size: "sm",
                    fullWidth: !0,
                    iconLeft: /* @__PURE__ */ e(A, { style: { width: "var(--icon-xs)", height: "var(--icon-xs)" } }),
                    onClick: u,
                    children: v
                  }
                ),
                /* @__PURE__ */ e(
                  "span",
                  {
                    style: {
                      fontSize: "var(--text-2xs)",
                      color: "var(--text-tertiary)",
                      textAlign: "center"
                    },
                    children: g
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
});
N.displayName = "FtuChecklist";
export {
  N as F
};
//# sourceMappingURL=FtuChecklist-D5PwnD3Q.js.map
